import React from "react";
import Header from "../Header/Header";
import Main from "../Main/Main";
export default function NotFound() {
  return (
    <>
      <Main></Main>
      <Header></Header>
      <div className="flex items-center justify-center w-full h-full fixed top-0 left-0 z-[-1]">
        <span className="text-white text-2xl">صفحه مورد نظر یافت نشد</span>
      </div>
    </>
  );
}
